import { actionCreator } from '@ardoq/rxbeach';
import {
  StartTrackingPayload,
  RecordSpanPayload,
  CompleteTrackingPayload,
  RemoveTrackingSessionPayload,
} from './types';

export const trackingStarted = actionCreator<StartTrackingPayload>(
  '[durationTracking] tracking started'
);

export const spanRecorded = actionCreator<RecordSpanPayload>(
  '[durationTracking] span recorded'
);

export const trackingCompleted = actionCreator<CompleteTrackingPayload>(
  '[durationTracking] tracking completed'
);

export const trackingSessionRemoved =
  actionCreator<RemoveTrackingSessionPayload>(
    '[durationTracking] tracking session removed'
  );

export const cleanupStaleSessions = actionCreator(
  '[durationTracking] cleanup stale sessions'
);
